import React from "react";
import Image from "components/image";
import Link from "components/link";
import { useSettings } from "hooks/useStore";
import { trackNavClick } from "analytics";

const ImageLink = ({ data }) => {
	const { toggleMenu } = useSettings(["toggleMenu"]);

	const handleOnClick = () => {
		toggleMenu(false);
		trackNavClick(data.title);
	};

	return (
		<div className="flex flex-col gap-3">
			<Image image={data.image} onClick={handleOnClick} />
			<Link to={data.image?.url} onClick={handleOnClick} data-type="image-link" className="text-xl font-bold">
				{data.title}
			</Link>
		</div>
	);
};

export default ImageLink;